import { errorHandler } from '@/Config/ErrorHandler';
import { host } from '@branding/config';
import { usePostHog } from 'posthog-js/react';

interface ISetUserMetrics {
	actionType: 'answerQuestion' | 'unfocusedTab' | 'focusedTab' | 'closedTab' | 'beginInvestigation';
	componentType: 'question' | 'investigationContext';
	timeSpent: number;
	sc: string | null;
	questionId?: string;
}
export const useSetUserMetrics = () => {
	const posthog = usePostHog();
	const sessionId = posthog.get_session_id();

	const setUserMetrics = ({ actionType, timeSpent, componentType, sc, questionId = '' }: ISetUserMetrics) => {
		const url = new URL(host + `/api/setUserMetrics`);
		const reqBody = {
			componentType: componentType,
			timeSpent: timeSpent,
			actionType: actionType,
			questionId: questionId,
			sc: sc ?? '',
			sessionId: sessionId,
		};

		try {
			fetch(url, {
				method: 'POST',
				body: JSON.stringify(reqBody),
				keepalive: true,
				headers: {
					'Content-Type': 'application/json',
				},
			}).then((res: Response) => {});
		} catch (err) {
			errorHandler(new Error('Error setting metrics'), { err });
			throw new Error(err as any);
		}
	};
	return { setUserMetrics };
};
